import { ca } from '@cian/analytics';

import { EChatbotPeriodicity } from '../../types/chatbot';

export const trackAnswerQuestionsClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Answer',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackSendMoreClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'SendMore',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackNewSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'NewSearch',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackStopSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'Stop',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackShowAllClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'ShowAll',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackTuneFrequencyClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: 'TuneFrequency',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

const AnalyticsPeriodicity: { [key in EChatbotPeriodicity]: string } = {
  [EChatbotPeriodicity.Daily]: 'Daily',
  [EChatbotPeriodicity.EveryThreeDays]: 'ThreeDays',
  [EChatbotPeriodicity.Weekly]: 'Weekly',
  [EChatbotPeriodicity.Never]: 'Never',
};

export const trackSetFrequencyClick = (periodicity?: EChatbotPeriodicity) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: periodicity ? AnalyticsPeriodicity[periodicity] : 'Unchanged',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
};

export const trackActionButtonClick = (analyticsType: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_sopr',
    label: analyticsType,
    page: {
      extra: {
        chat_id: 'chatbot',
        click_source: 'chat',
      },
    },
  });
};
